<template>
  <div class="custom-tab-box">
    <div
      class="tab-list"
      :class="selectTab == item.label ? 'tab-list-active' : ''"
      @click="checkTab(item.label)"
      v-for="item in tabData"
      :key="item.label"
    >
      <span style="position:relative;">{{ item.value }}
       <span class="tab-num" v-if="item.num">{{item.num}}</span></span>

    </div>
  </div>
</template>
<script>
export default {
  name: "CustomTabBox",
  components: {},
  props: {
    selectTab: {
      type: Number | String | Boolean,
      default: null,
    },
    tabData: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    checkTab(val) {
      if (this.selectTab === val) {
        return;
      }
      this.$emit("change", val);
    },
  },
};
</script>

<style scoped lang="scss">
.custom-tab-box {
  display: inline-block;
  //display: flex;
  //align-items: center;
  background-color: #f7f8fc;
  border-radius: 0.08rem;
  padding: 0.04rem;
  .tab-list {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    color: #000000;
    padding: 0.06rem 0.4rem;
    cursor: pointer;
    line-height: 1;
    font-size: 0.16rem;
    float: left;
    position: relative;
  }
  .tab-list-active {
    background-color: #ffffff;
    color: #1269ff;
    border-radius: 0.04rem;
    position: relative;
  }
  .tab-num{
    position: absolute;
    top: -0.2rem;
    right: -0.2rem;
    font-size: 0.2rem;
    background-color: rgba(255, 0, 0, 0.1);
    border-radius: 50%;
    color: red;
    min-height: 0.26rem;
    min-width: 0.26rem;
    text-align: center;
    line-height: 0.26rem;
  }
}
</style>
